export default {"src":"/_next/static/media/arrow-left-small.c0cbf6b9.svg","height":15,"width":9};